import { useTranslate } from '@refinedev/core';
import { Alert, Checkbox, Space, Typography } from 'antd';

/**
 * Q-ugc-1 A (the founder, 2026-10-03) — "I have the right to use this content": a PRACTICE ticks it before it
 * imports a form from a file or saves / revises its own worksheet (cc-homework, chapter "Worksheets —
 * Templates & library (portal, E34)"). Unticked by default; the help line says the practice is responsible
 * for what it imports or creates, copyright included. A refusal from the API (WORKSHEET_RIGHTS_NOT_CONFIRMED)
 * shows here, at the checkbox. CopingCard's own library publishing (the backoffice) never renders this.
 */
export const RightsConfirmation = ({
  checked,
  onChange,
  problem,
  disabled,
  testId,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  problem?: string | null;
  disabled?: boolean;
  /** the testid prefix — `<prefix>` is the checkbox, `<prefix>-error` the refusal. */
  testId: string;
}) => {
  const t = useTranslate();
  return (
    <Space direction="vertical" size={4} style={{ width: '100%' }}>
      <Checkbox
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testId}
      >
        {t('worksheets.rights.confirm')}
      </Checkbox>
      <Typography.Text type="secondary" style={{ fontSize: 12 }} data-testid={`${testId}-help`}>
        {t('worksheets.rights.help')}
      </Typography.Text>
      {problem ? <Alert type="error" showIcon message={problem} data-testid={`${testId}-error`} /> : null}
    </Space>
  );
};

/** The code the API refuses a save or an import with when the box was left unticked. */
export const RIGHTS_REFUSAL_CODE = 'WORKSHEET_RIGHTS_NOT_CONFIRMED';
